import React from "react";
import { logException, LOGEXCEPTION_UNHANDLED } from "src/backend/services/LoggingService";
import { FailureMessage, Header, LoginButton, LoginFailure, LoginOuter } from "../login/LoginComponents";

export const ErrorForm = ({error, resetErrorBoundary}) => {

  logException(LOGEXCEPTION_UNHANDLED, error);

  return (
    <LoginOuter>
      <LoginFailure>
        <Header color="#C65911">Unexpected error</Header>
        <FailureMessage>{error.message}</FailureMessage>
        <LoginButton onClick={resetErrorBoundary}>Retry</LoginButton>
      </LoginFailure>
    </LoginOuter>
  );

};